import React, { useEffect, useState } from "react"
import TableCustom from "src/components/Table/CustomTable"
import dayjs from "dayjs"
import ReportsService from "src/services/ReportService"
import PurchaseDetailModal from "../Modal/DetailModal"
import FilterCustom from "./Filter"
import ViewSimDetailModal from "../../SalesReport/Modal/ViewSimDetailModal"
import ReportPoolDataService from "src/services/ReportPoolDataService"
import { getDiscountTypeName, STATUS } from "src/constants/constants"
import PermissionGuard from "src/components/PermissionGuard"

function ListPurchase({
  refresh,
  setRefresh,
  tabStatus,
  permissions,
  setParentFilter,
  keyword,
  setKeyword,
}) {
  const [dataSource, setDataSource] = useState([])
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [loading, setLoading] = useState(false)
  const [summary, setSummary] = useState({})
  const [filter, setFilter] = useState({})
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [isSimModalOpen, setIsSimModalOpen] = useState(false)

  const fetchData = async (pagination, filter, keyword, tab) => {
    setLoading(true)
    setParentFilter(filter)
    try {
      const res = await ReportPoolDataService.getReportPackageReceiptM2M({
        page: pagination.current,
        per_page: pagination.pageSize,
        status: tab,
        filter: {
          ...filter,
        },
        keyword,
      })

      if (res?.success?.data) {
        // console.log("API trả về:", res.success.data);
        const formatted = res?.success?.data.map((item, index) => ({
          ...item,
          import_price: Number(item.import_price).toLocaleString(),
          total_price: Number(item.total_price).toLocaleString(),
        }))

        setDataSource(formatted)
        setSummary(res.success.amount || {})
        setPagination({
          ...pagination,
          total: res.success.total,
        })
      }
    } catch (err) {
      console.error("Lỗi:", err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(pagination, filter, keyword, tabStatus)
  }, [pagination.current, pagination.pageSize])
  useEffect(() => {
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined) {
        fetchData(pagination, filter, keyword, tabStatus)
      }
    }
  }, [refresh, filter, keyword, tabStatus])
  useEffect(() => {
    setPagination({
      ...pagination,
      current: 1,
    })
  }, [filter])

  // mở modal seri SIM
  const handleOpenSimModal = record => {
    setSelectedRecord(record)
    setIsSimModalOpen(true)
  }

  const handleCloseModals = () => {
    setIsDetailModalOpen(false)
    setIsSimModalOpen(false)
    setSelectedRecord(null)
  }
  const handleOpenDetailModal = record => {
    setSelectedRecord(record)
    setIsDetailModalOpen(true)
  }


  const columns = [
    { title: "Mã phiếu nhập kho", dataIndex: "code", align: "center" },
    {
      title: "Người tạo",
      dataIndex: "customer",
      key: "customer",
      render: customer => customer?.fullname || "",
      align: "center",
    },
    {
      title: "Ngày tạo",
      dataIndex: "created_at", // nhớ đúng key từ API (created_at, không phải create_at)
      key: "created_at",
      render: text => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
      align: "center",
    },
    { title: "Thuê bao chủ", dataIndex: "parent_phone", align: "center" },
    { title: "Mã gói cước", dataIndex: "package_code", align: "center" },
    { title: "Loại gói cước", dataIndex: "package_type", align: "center" },
    {
      title: "Dung lượng",
      dataIndex: "data_volume_gb",
      align: "center",
      render: value => value ? value + " GB" : ""
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      align: "center",
      render: value => {
        const status = STATUS[value];
        if (!status) return "";
        const { label, color } = status;
        return <span style={{ color, fontWeight: "bold" }}>{label}</span>;
      }
    },
    {
      title: "Tổng tiền trước chiết khấu",
      dataIndex: "import_price",
      key: "import_price",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    { title: "Loại chiết khấu", dataIndex: "discount_type", align: "center", render: value => getDiscountTypeName(value) },
    { title: "Chiết khấu (%)", dataIndex: "discount_value", align: "center", render: value => value ? Number(value) : 0 },
    {
      title: "Tổng tiền sau chiết khấu",
      dataIndex: "total_price",
      key: "total_price",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    { title: "Ghi chú", dataIndex: "note", align: "center" },
  ]
  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }

  return (
    <div>
      <div style={{ display: "flex" }}>
        <FilterCustom
          setFilter={setFilter}
          setKeyword={setKeyword}
        // tabStatus={tabStatus}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          margin: "10px 0",
          gap: "10px",
        }}
      >
        <div style={{ padding: "0 5px", color: "#007BFF", minWidth: "150px" }}>
          <strong>Tổng số đơn hàng: {pagination.total}</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#28A745", minWidth: "150px" }}>
          <strong>
            Tổng tiền trước chiết khấu: {Number(summary.import_price).toLocaleString()}
          </strong>
        </div>
        <div style={{ padding: "0 5px", color: "#FF0000", minWidth: "150px" }}>
          <strong>Tổng tiền sau chiết khấu:  {Number(summary.total_price).toLocaleString()}</strong>
        </div>
      </div>
      <TableCustom
        isPrimary
        columns={columns}
        dataSource={dataSource}
        showPagination
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        onChange={handleTableChange}
        onRow={(record, rowIndex) => {
          return {
            onClick: event => {
              setSelectedRecord(record); setIsDetailModalOpen(true)
            },
          }
        }}
        footerLeft={<div className="d-flex mt-20" />}
        widthScroll={1200}
        textEmpty="Không có dữ liệu!"
        scroll={{ x: "max-content" }}
        loading={loading}
      />
      {selectedRecord && (
        <PermissionGuard permission="poolData.reportPackage.detailReceipt">
          <PurchaseDetailModal
            open={isDetailModalOpen}
            onCancel={handleCloseModals}
            id={selectedRecord.ID}
          />
        </PermissionGuard>
      )}
      {isSimModalOpen && (
        <ViewSimDetailModal
          visible={isSimModalOpen}
          onClose={handleCloseModals}
          id={selectedRecord?.ID}
          api={ReportsService.detailSimPurchase}
          historyDetail={false}
        />
      )}
    </div>
  )
}

export default ListPurchase
